module.exports = __webpack_public_path__ + "static/media/welcome_0.65d6589c.png";